<template>
  <div class="section content">
    <div
      v-if="readOnly"
      class="columns"
    >
      <div class="column">
        <div class="message">
          <div class="message-body">
            <p>This section is disabled. Changes must be done by a system administrator.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column has-text-centered">
        <h2 class="title is-2">
          Department Access
        </h2>
        <div class="subtitle is-2">
          <div v-if="readOnly">
            You have access to manage the departments listed below
          </div>
          <div v-if="!readOnly">
            Select which departments this user has access to
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-centered">
      <template v-if="readOnly">
        <div class="column  is-half">
          <select
            class="dept-list"
            multiple
          >
            <option
              v-for="agency in getDropdownLabel(selectedAgencies, 'agencies').split(',')"
              :key="agency"
            >
              {{ agency }}
            </option>
          </select>
        </div>
      </template>
      <template v-else>
        <div class="column is-half">
          <v-selectmenu
            v-model="selectedAgencies"
            key-field="id"
            show-field="description"
            :data="agencies"
            :language="'en'"
            :multiple="true"
            :full-width="true"
            :query="true"
            :title="'Select Departments'"
          >
            <button
              id="selected-departments"
              type="button"
              class="sm-default-btn"
            >
              <div>
                <strong>Departments</strong>{{ selectedAgencies !== '' ? ': ' + getDropdownLabel(selectedAgencies, 'agencies') : '' }}
              </div>
            </button>
          </v-selectmenu>
        </div>
      </template>
    </div>
    <div class="validate-tooltip columns v-center-bottom v-arrow-center-top">
      <transition name="fade">
        <span
          v-if="selectedAgencies === '' && !readOnly"
          class="column shrink error popover"
          v-text="'Department admins must have access to at least one department'"
        />
      </transition>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { controlValueHelpers } from '@/mixins/controlValue';
import vSelectMenu from 'v-selectmenu';
Vue.use(vSelectMenu);

export default {
  name: 'DeptAccess',
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'user',
    },
    requester: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      agencies: [],
      selectedAgencies: '',
    };
  },
  watch: {
    selectedAgencies: {
      async handler (value) {
        let emitValue;

        if (value === '') {
          emitValue = [];
        } else {
          emitValue = this.selectedAgencies.split(",").map(Number);
        }

        this.$emit('deptAccess', emitValue);
      },
    },
  },
  async created () {
    await this.initialFetch();
    await this.initialAssign();
    this.$emit('deptAccessReady', true);
  },
  methods: {
    async initialAssign () {
      this.agencies = this.cloneObj(this.$store.getters[ 'admin/activeControlValues' ]('agency'));

      if (this.requester === 'deptHead') {
        this.agencies = this.agencies.filter(agency => this.$store.state.user.deptAccess.includes(agency.id));
      }

      if (this.type === 'tempUser') {
        this.selectedAgencies = this.$store.state.user.tempDeptAccess ? this.$store.state.user.tempDeptAccess.join(',') : '';
      } else if (this.type === 'user') {
        this.selectedAgencies = this.$store.state.user.deptAccess ? this.$store.state.user.deptAccess.join(',') : '';
      }
    },
    async initialFetch () {
      let promises = [];
      promises.push(this.$store.dispatch('admin/getControlValue', 'agency'));
      if (this.type === 'user') {
        promises.push(this.$store.dispatch('user/fetchUserDepts'));
      } else if (this.type === 'tempUser') {
        promises.push(this.$store.dispatch('user/fetchUserDepts'));
        promises.push(this.$store.dispatch('user/fetchUserDepts', this.$store.state.user.tempId));
      }
      await Promise.all(promises);
    },
    getDropdownLabel (keys, variable) {
      const keysArray = keys.split(",");
      let labels = [];
      keysArray.forEach(key => {
        this[variable].forEach(item => {
          if (item.id == key) {
            labels.push(item.description);
          }
        });
      });
      return labels.join(', ');
    },
  },
};
</script>

<style scoped>
  .dept-list {
    width: 100%;
  }
</style>
